import {
	createSlice,
	createAsyncThunk,
	AsyncThunk,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	ActivateBankBoxPayload,
	AssignBankBoxPayload,
	BVNActionPayload,
	BVNActionResponse,
	BankBoxCreateUserPayload,
	BankBoxState,
	BankboxMerchantProfile,
	GetAllBankBoxQueryParams,
} from './types';
import { logger } from '../services/logger';
import { toast } from '@ravenpay/raven-bank-ui';
import axios from '../utils/banbox_axios';
import mainAxios from '../utils/axios';
import defaultAxios, { Axios, AxiosError } from 'axios';
import {
	capitalizeFirstLetter,
	getCookie,
	triggerDownload,
} from '../utils/helper/Helper';
import env from '../env';
import { decrypt2 } from '../utils/encrypt';
import { formatMerkList } from '../pages/dashboard/bankbox/compliance/compliance-cac-verification/uploadfile/UploadPages/CacDetails';

type NinData = {
	email: string;
	status: number;
	[key: string]: any;
};

export interface BankBoxRequests {
	createUser: AsyncThunk<any, BankBoxCreateUserPayload, any>;
	deviceReq: AsyncThunk<any, BankBoxCreateUserPayload, any>;
	raiseDispute: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	updateUser: AsyncThunk<any, BankBoxCreateUserPayload, any>;
	updateBusinessMerchant: AsyncThunk<any, any, any>;
	updateUserFee: AsyncThunk<any, any, any>;
	getDashboardSummary: any;
	uploadLogo: any;
	getTopTransacting: AsyncThunk<any, any, any>;
	getBankboxBanks: AsyncThunk<any, any, any>;
	getMerBIZ: AsyncThunk<any, any, any>;
	getRoles: AsyncThunk<any, any, any>;
	getInvitationDetails: AsyncThunk<any, any, any>;
	acceptInviteTeamMember: AsyncThunk<any, any, any>;
	getAllTeams: AsyncThunk<any, any, any>;
	getAllSettlements: AsyncThunk<any, any, any>;
	getAllSettlementsHistory: AsyncThunk<any, any, any>;
	getAllSettlementSearch: AsyncThunk<any, any, any>;
	getAllSettlementHistorySearch: AsyncThunk<any, any, any>;
	getPolicies: AsyncThunk<any, any, any>;
	getSingleRole: AsyncThunk<any, any, any>;
	getSettingsConfigBankbox: AsyncThunk<any, any, any>;
	getBankboxPartner: AsyncThunk<any, any, any>;
	getBankboxStates: AsyncThunk<any, any, any>;
	getBankboxLocations: AsyncThunk<any, any, any>;
	getBankboxLgaByStates: AsyncThunk<any, any, any>;
	createFeeCategory: AsyncThunk<any, any, any>;
	editFeeCategory: AsyncThunk<any, any, any>;
	resendTeamInvite: AsyncThunk<any, any, any>;
	removeTeamMember: AsyncThunk<any, any, any>;
	inviteTeamMember: AsyncThunk<any, any, any>;
	manageTeamMember: AsyncThunk<any, any, any>;
	createRole: AsyncThunk<any, any, any>;
	updateRole: AsyncThunk<any, any, any>;
	createLocationPickUp: AsyncThunk<any, any, any>;
	editLocationPickUp: AsyncThunk<any, any, any>;
	changeRequestStatus: AsyncThunk<any, any, any>;
	sendCustomEmail: AsyncThunk<any, any, any>;
	changeDisputeStatus: AsyncThunk<any, any, any>;
	changeTerminalActiveDays: AsyncThunk<any, any, any>;
	getBankboxBankValidate: AsyncThunk<any, any, any>;
	addSettleMentAccountPartner: AsyncThunk<any, any, any>;
	editSettleMentAccountPartner: AsyncThunk<any, any, any>;
	requestSettleMentAccountPartner: AsyncThunk<any, any, any>;
	requestSettleMentAccountMerchant: AsyncThunk<any, any, any>;
	activateBankbox: AsyncThunk<any, ActivateBankBoxPayload, any>;
	getAllBankBox: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getVirtualTerminal: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getAllBankBoxForMerchant: AsyncThunk<any, any, any>;
	getVirtualBankBoxForMerchant: AsyncThunk<any, any, any>;
	searchVirtualBankBoxForMerchant: AsyncThunk<any, any, any>;
	setInactiveDaysTerminal: AsyncThunk<any, any, any>;
	singleTerminal: AsyncThunk<any, any, any>;
	getAllBankBoxRequest: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getAllSingleBankBoxRequest: AsyncThunk<any, any, any>;
	getAllDisputes: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	handleBVNAction: AsyncThunk<any, any, any>;
	handleNINAction: AsyncThunk<any, any, any>;
	getAllBVN: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	searchBVNRecords: AsyncThunk<any, any, any>;
	searchNINRecords: AsyncThunk<any, any, any>;
	getAllNIN: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getAllCAC: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getAllAddress: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	searchMerchantAddresses: AsyncThunk<any, any, any>;
	getSingleAllDisputes: AsyncThunk<any, any, any>;
	getAllFees: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getAllFeesWithoutPagination: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportUsers: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportDisputes: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportVirtualTerminal: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportBVN: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportAirtimeRecords: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportDataRecords: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportElectricityRecords: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportCableRecords: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportBettingRecords: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportNIN: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportCAC: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportAddress: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportFees: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getProfile: AsyncThunk<any, any, any>;
	exportBankboxes: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportEODBankboxes: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	assignBankbox: AsyncThunk<any, AssignBankBoxPayload, any>;
	assignBankboxVirtual: AsyncThunk<any, any, any>;
	updateProfile: AsyncThunk<any, BankboxMerchantProfile, any>;
	deactivateBankbox: AsyncThunk<any, { serial_no: string }, any>;
	deleteBankbox: AsyncThunk<any, { serial_no: string }, any>;
	deleteLocation: AsyncThunk<any, { id: string }, any>;
	reactivateBankbox: AsyncThunk<any, { serial_no: string }, any>;
	setBankboxKey: AsyncThunk<any, { bankbox_key: string }, any>;
	getSingleUser: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getSingleUserMerchant: AsyncThunk<any, any, any>;
	generateAccountNumberVirtual: AsyncThunk<any, any, any>;
	getSingleBankbox: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getSingleMerchantBankbox: AsyncThunk<any, any, any>;
	getSingleMerchantVirtualBankbox: AsyncThunk<any, any, any>;
	getSingleBankboxFlier: AsyncThunk<any, { account_number: string }, any>;
	getAllUsers: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	// getSingle: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getAllTransactions: AsyncThunk<any, any, any>;
	getMerchantAllTransactions: AsyncThunk<any, any, any>;
	fetchSettlementRequest: AsyncThunk<any, any, any>;
	getMerchantAllSettlement: AsyncThunk<any, any, any>;
	getTransactionSingle: AsyncThunk<any, any, any>;
	getChartData: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	getSingleTransaction: AsyncThunk<any, any, any>;
	exportBankboxTransaction: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportBankboxSettlement: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportMerchantTransaction: AsyncThunk<any, GetAllBankBoxQueryParams, any>;
	exportBankboxSettlementHistory: AsyncThunk<
		any,
		GetAllBankBoxQueryParams,
		any
	>;

	// getAllTransactions: AsyncThunk<any, any, any>;
	// getPaymentLink:AsyncThunk<any, any, any>
}

const getDashboardSummary = createAsyncThunk(
	'/bankbox/dashboardData',
	async (payload, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/dashboard`);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setSummary(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getProfile = createAsyncThunk(
	'/bankbox/profile',
	async (payload, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/get_merchant`);
			// logger.log(data?.data);
			//  //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				// thunkAPI.dispatch(setProfile(data?.data?.data));
				thunkAPI.dispatch(setPartnerSettlementInfo(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const inviteTeamMember = createAsyncThunk(
	'/atlas/pdon/invite-team-member',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/team/invite`, payload);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const manageTeamMember = createAsyncThunk(
	'/atlas/pdon/manage-team-member',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/team/update`, payload);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const setInactiveDaysTerminal = createAsyncThunk(
	'/atlas/pdon/set-inactive-termnal-days',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/device/inactive_days`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const createUser = createAsyncThunk(
	'/atlas/pdon/activate_bank_box',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/create_new_user`, payload);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const deviceReq = createAsyncThunk(
	'/atlas/pdon/device/request_device',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/device/request_device`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const raiseDispute = createAsyncThunk(
	'/atlas/pdon/create_dispute',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/create_dispute`, payload);
			// logger.log(data?.data);
			payload;

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}

			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			console.error('Error response:', error.response);

			if (error.message === 'Network Error') {
				toast.error('Network Error. Please check your connection.', {
					position: 'top-right',
				});
			} else if (error.response) {
				if (
					error.response.data.status === 'fail' &&
					error.response.status !== 401
				) {
					toast.error(error.response.data.message || 'Unknown error', {
						position: 'top-right',
					});
					return thunkAPI.rejectWithValue(error.response.data);
				}
			} else {
				toast.error('An unexpected error occurred.', {
					position: 'top-right',
				});
			}
			return thunkAPI.rejectWithValue(error);
		}
	}
);

const updateUser = createAsyncThunk(
	'/bankbox/updateUser',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/update_merchant`, payload);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const updateBusinessMerchant = createAsyncThunk(
	'/bankbox/updateUser-business-merchant',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/request_business_update`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const updateUserFee = createAsyncThunk(
	'/bankbox/updateUser-fee',
	async (payload: BankBoxCreateUserPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/merchant_change_fee`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const activateBankbox = createAsyncThunk(
	'/bankbox/onboard',
	async (payload: ActivateBankBoxPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/onboard`, payload);
			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return data;
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const uploadLogo = createAsyncThunk(
	'/bankbox/upload',
	async (payload: FormData, thunkAPI) => {
		try {
			const { data } = await defaultAxios.post(
				`${env.bankbox_api}atlas/pdon/upload`,
				payload,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
						Authorization: 'Bearer ' + getCookie('token'),
						'x-pos-key': getCookie('x-pos-key'),
					},
				}
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return data;
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const setBankboxKey = createAsyncThunk(
	'/bankbox/key_update',
	async (payload: { bankbox_key: string }, thunkAPI) => {
		try {
			const { data } = await mainAxios.post(`/web/set_bankbox_key`, payload);
			// //(data, '---------------kytyuioljh--------------');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return data;
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllBankBox = createAsyncThunk(
	'/bankbox/get_all_bankbox',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_bankbox?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${
					payload?.set_terminal_inactive_days
						? `&terminal_inactive_days=${payload?.set_terminal_inactive_days}`
						: ''
				}
        `
			);
			// //(data, '----------all terminals------');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllBankBox(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

/* remove */
const getVirtualTerminal = createAsyncThunk(
	'/bankbox/get_all_bankbox_virtual_terminal',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/virtual_terminals?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&perPage=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${
					payload?.set_terminal_inactive_days
						? `&terminal_inactive_days=${payload?.set_terminal_inactive_days}`
						: ''
				}
        `
			);
			// //(data, '----------all terminals------');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllBankBoxVirtual(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllBankBoxForMerchant = createAsyncThunk(
	'/bankbox/get_all_bankbox',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_bankbox?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${
					payload?.set_terminal_inactive_days
						? `&terminal_inactive_days=${payload?.set_terminal_inactive_days}`
						: ''
				}
        `
			);
			// console.log(data, '----------all terminals------');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				// thunkAPI.dispatch(setAllBankBoxMerchant(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getVirtualBankBoxForMerchant = createAsyncThunk(
	'/bankbox/get_all_bankbox_virtual_terminal',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { perPage, email, page, search } = payload;

			const searchParams = new URLSearchParams();

			if (perPage) searchParams.append('perPage', perPage);
			if (page) searchParams.append('page', String(page));
			if (email) searchParams.append('email', email);

			const query = searchParams.toString();

			const { data } = await axios.get(
				`/atlas/pdon/virtual_terminals?${query}`
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setVirtualBankBoxMerchant(data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const searchVirtualBankBoxForMerchant = createAsyncThunk(
	'/bankbox/search_bankbox_virtual_terminal',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { perPage, email, page, search } = payload;

			const searchParams = new URLSearchParams();

			if (perPage) searchParams.append('perPage', perPage);
			if (page) searchParams.append('page', String(page));
			if (email) searchParams.append('email', email);
			if (search) searchParams.append('search', search);

			const query = searchParams.toString();

			const { data } = await axios.get(
				`/atlas/pdon/get_virtual_terminal?${query}`
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setVirtualBankBoxMerchant(data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const singleTerminal = createAsyncThunk(
	'/bankbox/single_all_bankbox',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_bankbox?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${
					payload?.set_terminal_inactive_days
						? `&terminal_inactive_days=${payload?.set_terminal_inactive_days}`
						: ''
				}
        `
			);
			// //(data, '----------all terminals------');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllBankBox(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleRole = createAsyncThunk(
	'/bankbox/get_single_role',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/single_role?role_id=${payload?.role_id || ''}`
			);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setSingleRole(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getBankboxPartner = createAsyncThunk(
	'/bankbox/get_all_bankbox_partner',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/get_current_partner`);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setBankBoxPartnerType(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getBankboxBanks = createAsyncThunk(
	'/bankbox/get_all_bankbox_banks',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/get_banks`);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setBankBoxBanks(formatBankList(data?.data?.data)));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getMerBIZ = createAsyncThunk(
	'/bankbox/get_all_mer_biz',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/search_merchants`, payload);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				const formatMerchantList = (list?: []) => {
					if (Number(list?.length) > 0) {
						const newList = list?.map((chi: any) => {
							return {
								...chi,
								label: chi?.poseidon_business_name,
								value: chi?.poseidon_email,
							};
						});
						return newList;
					}
				};
				const formatList = formatMerchantList(data?.data?.data);

				thunkAPI.dispatch(setmerbiz(formatList));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getBankboxBankValidate = createAsyncThunk(
	'/bankbox/get_all_bankbox_bank_validate',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/account_number_lookup`,
				payload
			);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// thunkAPI.dispatch(setBankBoxBanks(formatBankList(data?.data?.data)));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const addSettleMentAccountPartner = createAsyncThunk(
	'/bankbox/add-settle-ment-account-partner',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/add_settlement`, payload);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				toast.success(capitalizeFirstLetter(data?.data?.message), {
					position: 'top-right',
				});
				// thunkAPI.dispatch(setBankBoxBanks(formatBankList(data?.data?.data)));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const editSettleMentAccountPartner = createAsyncThunk(
	'/bankbox/edit-settle-ment-account-partner',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/update_settlement`,
				payload
			);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				toast.success(capitalizeFirstLetter(data?.data?.message), {
					position: 'top-right',
				});
				// thunkAPI.dispatch(setBankBoxBanks(formatBankList(data?.data?.data)));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const requestSettleMentAccountPartner = createAsyncThunk(
	'/bankbox/request-settle-ment-account-partner',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/process_partner_settlement`,
				payload
			);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				toast.success(capitalizeFirstLetter(data?.data?.message), {
					position: 'top-right',
				});
				// thunkAPI.dispatch(setBankBoxBanks(formatBankList(data?.data?.data)));
				return data;
			}
		} catch (error: any) {
			// //(error);

			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const requestSettleMentAccountMerchant = createAsyncThunk(
	'/bankbox/request-settle-ment-account-merchant',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/request_settlement`,
				payload
			);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				toast.success(capitalizeFirstLetter(data?.data?.message), {
					position: 'top-right',
				});
				// thunkAPI.dispatch(setBankBoxBanks(formatBankList(data?.data?.data)));
				return data;
			}
		} catch (error: any) {
			// //(error);

			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getBankboxStates = createAsyncThunk(
	'/bankbox/get_all_bankbox_states',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/regions`);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setBankBoxStates(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getBankboxLgaByStates = createAsyncThunk(
	'/bankbox/get_all_bankbox_lga__states',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/lgas?region=${payload?.region}`
			);

			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data.data.data);

				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setBankBoxLga(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllBankBoxRequest = createAsyncThunk(
	'/bankbox/get_all_bankbox_request',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_bankbox_request?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllBankBoxRequest(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllSingleBankBoxRequest = createAsyncThunk(
	'/bankbox/get_single_all_bankbox_request',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		//(payload);

		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_bankbox_request?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);
				// 'api', data?.data?.data;
				thunkAPI.dispatch(setAllSingleBankBoxRequest(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllDisputes = createAsyncThunk(
	'/bankbox/get_all_dispute',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_disputes?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllDisputes(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const handleBVNAction = createAsyncThunk(
	'/bankbox/merchant/verification',
	async (
		{
			action,
			email,
		}: { action: 'confirm' | 'reject' | 'revoke'; email: string },
		thunkAPI
	) => {
		const requestBody = {
			merchantEmail: email,
			type: 'bvn',
		};
		try {
			const { data } = await axios.post(
				`/atlas/pdon/merchant/verification/${action}`,
				requestBody,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				}
			);

			const resData = {
				...data.data,
				message: data.message,
			};

			if (data?.status === 'fail') {
				toast.error(data?.message || 'An error occurred');
				return thunkAPI.rejectWithValue(resData);
			}

			if (data?.status === 'success') {
				toast.success(data?.data?.message || 'Action completed successfully');
				return resData;
			}
		} catch (error: any) {
			const backendMessage =
				error?.response?.data?.message || 'An unexpected error occurred.';
			toast.error(backendMessage);
			return thunkAPI.rejectWithValue(error?.response?.data || error);
		}
	}
);

export const handleNINAction = createAsyncThunk(
	'/bankbox/merchant/verification',
	async (
		{
			action,
			email,
		}: { action: 'confirm' | 'reject' | 'revoke'; email: string },
		thunkAPI
	) => {
		const requestBody = {
			merchantEmail: email,
			type: 'nin',
		};
		try {
			const { data } = await axios.post(
				`/atlas/pdon/merchant/verification/${action}`,
				requestBody,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				}
			);

			const resData = {
				...data.data,
				message: data.message,
			};

			if (data?.status === 'fail') {
				toast.error(data?.message || 'An error occurred');
				return thunkAPI.rejectWithValue(resData);
			}
			//('API', data);

			if (data?.status === 'success') {
				toast.success(data?.data?.message || 'Action completed successfully');
				return resData;
			}
		} catch (error: any) {
			const backendMessage =
				error?.response?.data?.message || 'An unexpected error occurred.';
			toast.error(backendMessage);
			return thunkAPI.rejectWithValue(error?.response?.data || error);
		}
	}
);

export const handleAddressAction = createAsyncThunk(
	'/bankbox/merchant/verification',
	async (
		{
			action,
			email,
		}: { action: 'confirm' | 'reject' | 'revoke'; email: string },
		thunkAPI
	) => {
		const requestBody = {
			merchantEmail: email,
			type: 'address',
		};
		try {
			const { data } = await axios.post(
				`/atlas/pdon/merchant/verification/${action}`,
				requestBody,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				}
			);

			const resData = data.data;

			if (data?.status === 'fail') {
				toast.error(
					typeof data?.data === 'string' ? data?.data : data?.message
				);
				return thunkAPI.rejectWithValue(resData);
			}

			if (data?.status === 'success') {
				toast.success(data?.data?.message || 'Action completed successfully');
				return resData;
			}
		} catch (error: any) {
			const backendMessage =
				error?.response?.data?.message || 'An unexpected error occurred.';
			toast.error(backendMessage);
			return thunkAPI.rejectWithValue(error?.response?.data || error);
		}
	}
);

export const handleCACAction = createAsyncThunk(
	'/bankbox/merchant/verification',
	async (
		{
			action,
			email,
		}: { action: 'confirm' | 'reject' | 'revoke'; email: string },
		thunkAPI
	) => {
		const requestBody = {
			merchantEmail: email,
			type: 'cac',
		};
		try {
			const { data } = await axios.post(
				`/atlas/pdon/merchant/verification/${action}`,
				requestBody,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				}
			);

			const resData = data.data;

			if (data?.status === 'fail') {
				toast.success(data?.data?.message || 'Action completed successfully');
				return thunkAPI.rejectWithValue(resData);
			}

			if (data?.status === 'success') {
				toast.success(data?.data?.message || 'Action completed successfully');
				return resData;
			}
		} catch (error: any) {
			const backendMessage =
				error?.response?.data?.message || 'An unexpected error occurred.';
			toast.error(backendMessage);
			return thunkAPI.rejectWithValue(error?.response?.data || error);
		}
	}
);

export const handleApproveStatusAction = createAsyncThunk(
	'/bankbox/merchant/status/update',
	async (
		payload: { id: number; status: 'approved' | 'rejected' | string },
		thunkAPI
	) => {
		try {
			const { data } = await axios.post(
				'/atlas/pdon/device/status',
				{
					id: payload.id,
					status: payload.status,
				},
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				}
			);

			const resData = data.data;

			if (data?.status === 'fail') {
				toast.error(data?.data?.message || 'Action failed');
				return thunkAPI.rejectWithValue(resData);
			}

			toast.success(data?.data?.message || 'Action successful');
			return resData;
		} catch (error: any) {
			const backendMessage =
				error?.response?.data?.message || 'An unexpected error occurred.';
			toast.error(backendMessage);
			return thunkAPI.rejectWithValue(error?.response?.data || error);
		}
	}
);

export const getAllBVN = createAsyncThunk(
	'/bankbox/merchant/bvn-data',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const params = new URLSearchParams();

			if (payload.page) params.append('page', String(payload.page));
			if (payload.per_page) params.append('per_page', String(payload.per_page));
			if (payload.start_date) params.append('start_date', payload.start_date);
			if (payload.stop_date) params.append('stop_date', payload.stop_date);
			if (payload.status && payload.status !== 'reset')
				params.append('status', payload.status);
			if (payload.region) params.append('region', payload.region);
			if (payload.range) params.append('range', String(payload.range));
			if (payload.search) params.append('search', payload.search);
			if (payload.business_name)
				params.append('business_name', payload.business_name);
			if (payload.email) params.append('email', payload.email);

			const url = `/atlas/pdon/merchant/bvn-data?${params.toString()}`;

			let response;

			try {
				response = await axios.get(url, {
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${getCookie('token') || ''}`,
						'x-pos-key': getCookie('x-pos-key') || '',
					},
				});
			} catch (error: any) {
				const errMsg =
					error.response?.data?.message || error.message || 'Network error';
				console.error('Axios Error:', error);
				toast.error(errMsg);
				return thunkAPI.rejectWithValue({ message: errMsg });
			}

			const { data } = response || {};

			if (data.status === 'success') {
				thunkAPI.dispatch(setAllBVN(data.data.data || []));
				return data;
			} else {
				return thunkAPI.rejectWithValue(data);
			}
		} catch (error: any) {
			// Just in case something else fails
			const errMsg = error?.message || 'Unexpected error';
			console.error('Unhandled Error:', error);
			toast.error(errMsg);
			return thunkAPI.rejectWithValue({ message: errMsg });
		}
	}
);

export const searchBVNRecords = createAsyncThunk(
	'/merchant/bvn-data/search',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const data = await axios.get(
				`/atlas/pdon/merchant/bvn-data/search?search=${payload.search}${
					payload.per_page ? `&page=${payload.per_page}` : ''
				}${payload.per_page ? `&perPage=${payload.per_page}` : ''}`
			);

			if (data?.data?.status === 'fail') {
				if (typeof data?.data?.data === 'string') {
					toast.error(data?.data.data, {
						position: 'top-right',
					});
				} else {
					toast.error(data?.data.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.data?.status === 'success') {
				thunkAPI.dispatch(setAllBVN(data?.data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const searchNINRecords = createAsyncThunk(
	'/merchant/nin-data/search',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const data = await axios.get(
				`/atlas/pdon/merchant/nin-data/search?search=${payload.search}${
					payload.per_page ? `&page=${payload.per_page}` : ''
				}${payload.per_page ? `&perPage=${payload.per_page}` : ''}`
			);

			if (data?.data?.status === 'fail') {
				if (typeof data?.data?.data === 'string') {
					toast.error(data?.data.data, {
						position: 'top-right',
					});
				} else {
					toast.error(data?.data.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.data?.status === 'success') {
				thunkAPI.dispatch(setAllNIN(data?.data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportBVN = createAsyncThunk(
	'/bankbox/merchant/bvn-data/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant/bvn-data/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? `&per_page=${payload.per_page}` : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportAirtimeRecords = createAsyncThunk(
	'/bankbox/airtime/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/bill/airtime/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);
const exportDataRecords = createAsyncThunk(
	'/bankbox/data/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/bill/data/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);
const exportElectricityRecords = createAsyncThunk(
	'/bankbox/bill/electricity/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/bill/electricity/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);
const exportCableRecords = createAsyncThunk(
	'/bankbox/bill/cable/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/bill/cable/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);
const exportBettingRecords = createAsyncThunk(
	'/bankbox/bill/bet/expor',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/bill/bet/expor?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const getAllNIN = createAsyncThunk(
	'/bankbox/merchant/nin-data',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant/nin-data?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				//(data?.data?.data);
				thunkAPI.dispatch(setAllNIN(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportNIN = createAsyncThunk(
	'/bankbox/merchant/nin-data/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant/nin-data/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const getAllCAC = createAsyncThunk(
	'/bankbox/merchant/cac-data',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant/cac-data?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				//(data?.data?.data);

				thunkAPI.dispatch(setAllCAC(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportCAC = createAsyncThunk(
	'/bankbox/merchant/cac-data/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant/cac-data/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const getAllAddress = createAsyncThunk(
	'/bankbox/merchant/address-data',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const params = new URLSearchParams();

			if (payload.page) params.append('page', String(payload.page));
			if (payload.per_page) params.append('per_page', String(payload.per_page));
			if (payload.start_date) params.append('start_date', payload.start_date);
			if (payload.stop_date) params.append('stop_date', payload.stop_date);
			if (payload.status && payload.status !== 'reset')
				params.append('status', payload.status);
			if (payload.region) params.append('region', payload.region);
			if (payload.range) params.append('range', String(payload.range));
			if (payload.search) params.append('search', payload.search);
			if (payload.business_name)
				params.append('business_name', payload.business_name);
			if (payload.email) params.append('email', payload.email);

			const url = `/atlas/pdon/merchant/address-data?${params.toString()}`;
			const { data } = await axios.get(url);

			if (data.status === 'success') {
				thunkAPI.dispatch(setAllAddress(data.data.data || []));
				return data;
			} else {
				return thunkAPI.rejectWithValue(data);
			}
		} catch (error: any) {
			const errMsg =
				error.response?.data?.message || error.message || 'Network error';
			toast.error(errMsg);
			return thunkAPI.rejectWithValue({ message: errMsg });
		}
	}
);

export const searchMerchantAddresses = createAsyncThunk(
	'merchant/searchAddresses',
	async (
		payload: {
			page?: number | string;
			per_page?: number | string;
			startDate?: string;
			stopDate?: string;
			search?: string;
		},
		thunkAPI
	) => {
		try {
			const {
				page = 1,
				per_page = 20,
				startDate = '',
				stopDate = '',
				search = '',
			} = payload;

			const queryParams = new URLSearchParams({
				page: page.toString(),
				pagePage: per_page.toString(),
			});

			if (startDate) queryParams.append('startDate', startDate);
			if (stopDate) queryParams.append('stopDate', stopDate);
			if (search) queryParams.append('search', search);

			const url = `/atlas/pdon/merchant/address-data/search?${queryParams.toString()}`;

			const { data } = await axios.get(url, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${getCookie('token') || ''}`,
					'x-pos-key': getCookie('x-pos-key') || '',
				},
			});

			if (data?.status === 'success') {
				thunkAPI.dispatch(setAllAddress(data?.data?.data || []));
				return data;
			} else {
				toast.error(data?.message || 'Search failed.', {
					position: 'top-right',
				});
				return thunkAPI.rejectWithValue(data);
			}
		} catch (error: any) {
			const errMsg =
				error?.response?.data?.message ||
				error?.message ||
				'Something went wrong';
			toast.error(errMsg, { position: 'top-right' });
			return thunkAPI.rejectWithValue(
				error?.response?.data || { message: errMsg }
			);
		}
	}
);

const exportAddress = createAsyncThunk(
	'/bankbox/merchant/address-data/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant/address-data/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleAllDisputes = createAsyncThunk(
	'/bankbox/get_all_single_dispute',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			// //(payload);
			const { data } = await axios.get(
				`/atlas/pdon/get_all_disputes?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				//(data?.data?.data);

				thunkAPI.dispatch(setSingleAllDisputes(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllFees = createAsyncThunk(
	'/bankbox/get_all_fees',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get/partners_fee_details?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllFees(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getBankboxLocations = createAsyncThunk(
	'/bankbox/get_all_locations',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_delivery_location?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// //(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data?.data?.data);

				thunkAPI.dispatch(setAllLocations(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllFeesWithoutPagination = createAsyncThunk(
	'/bankbox/get_all_fees_no_pagination',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/fee_categories?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// //(data);

				thunkAPI.dispatch(setAllFeesNoPage(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportUsers = createAsyncThunk(
	'/bankbox/export_bankbox_users',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/export_bankbox_users?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportDisputes = createAsyncThunk(
	'/bankbox/export_disputes',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/export_disputes?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

/* remove */
const exportVirtualTerminal = createAsyncThunk(
	'/bankbox/export_disputes_virtual',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/virtual_terminals/export?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportFees = createAsyncThunk(
	'/bankbox/export_fees',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/export_fees?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportBankboxes = createAsyncThunk(
	'/bankbox/export_bankboxs',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/export_bankboxs?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportEODBankboxes = createAsyncThunk(
	'/bankbox/export_bankboxs_eod',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/generate_eod_report`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const createFeeCategory = createAsyncThunk(
	'/bankbox/create-fee-category',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(`/atlas/pdon/add/fee_details`, payload);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const editFeeCategory = createAsyncThunk(
	'/bankbox/edit-fee-category',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(`/atlas/pdon/update/fee`, payload);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const createLocationPickUp = createAsyncThunk(
	'/bankbox/create-location-pick-up',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/add_delivery_location`,
				payload
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const editLocationPickUp = createAsyncThunk(
	'/bankbox/edit-location-pick-up',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/update_delivery_location`,
				payload
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const checkEmailExist = createAsyncThunk(
	'/web/check_email_exist',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post('/atlas/pdon/check_partner', payload);
			// //(data);

			if (data?.status === 'fail') {
				if (typeof data.data === 'string') {
					// toast.error(data.data);
					return data;
				}
				// toast.error(data?.data?.message, {
				// 	position: 'top-right',
				// });
				else return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });

				return data;
			}
		} catch (error: any) {
			// //(error);

			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response?.data?.status === 'fail' &&
				error.response?.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getRoles = createAsyncThunk(
	'/bankbox/get_roles',
	async (payload, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/role
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				thunkAPI.dispatch(setRoles(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const acceptInviteTeamMember = createAsyncThunk(
	'/bankbox/accept-invite-team-member',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/team/invite/accept`,
				payload
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllTeams = createAsyncThunk(
	'/bankbox/get_all_teams',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/team?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&perPage=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}${
					payload.status ? '&status=' + payload.status : ''
				}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				thunkAPI.dispatch(setTeams(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getPolicies = createAsyncThunk(
	'/bankbox/get_policies',
	async (payload, thunkAPI) => {
		try {
			const { data } = await axios.get(`/atlas/pdon/policies`);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				thunkAPI.dispatch(setPolicies(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getInvitationDetails = createAsyncThunk(
	'/bankbox/get_invitation_details',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`atlas/pdon/team/invite/validate?invitation_token=${
					payload?.invitation_token || ''
				}`
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// thunkAPI.dispatch(setPolicies(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const sendCustomEmail = createAsyncThunk(
	'/bankbox/send-custom-email',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/send_custom_response`,
				payload
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const changeDisputeStatus = createAsyncThunk(
	'/bankbox/change-dispute-status',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/update_dispute_status`,
				payload
			);
			//(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const changeTerminalActiveDays = createAsyncThunk(
	'/bankbox/change-terminal-active-days',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`atlas/pdon/set_terminal_inactive_days`,
				payload
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const resendTeamInvite = createAsyncThunk(
	'/bankbox/resend-team-invites',
	async (payload: any, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(
				`/atlas/pdon/team/invite/resend`,
				payload
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				!payload?.dont_toast &&
					toast.success(data?.data?.message, {
						position: 'top-right',
					});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const removeTeamMember = createAsyncThunk(
	'/bankbox/remove-team-member',
	async (payload: any, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(`/atlas/pdon/team/delete`, payload);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const changeRequestStatus = createAsyncThunk(
	'/bankbox/change-request-status',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(`/atlas/pdon/update_request`, payload);
			// //(data);

			//('API response:', data);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const assignBankbox = createAsyncThunk(
	'/bankbox/assign',
	async (payload: AssignBankBoxPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/assign_bank_box2`,
				payload
			);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const assignBankboxVirtual = createAsyncThunk(
	'/bankbox/assign-virtual',
	async (payload: any, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/virtual_terminals/create`,
				payload
			);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const createRole = createAsyncThunk(
	'/bankbox/create-role',
	async (payload: AssignBankBoxPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/role/create`, payload);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const updateRole = createAsyncThunk(
	'/bankbox/update-role',
	async (payload: AssignBankBoxPayload, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/role/update`, payload);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const updateProfile = createAsyncThunk(
	'/bankbox/update',
	async (payload: BankboxMerchantProfile, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.post(`/atlas/pdon/settings`, payload);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				//  //(data);

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const deactivateBankbox = createAsyncThunk(
	'/bankbox/deactivate_bank_box',
	async (payload: { serial_no: string }, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/deactivate_bank_box`,
				payload
			);
			logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const deleteBankbox = createAsyncThunk(
	'/bankbox/delete_bank_box',
	async (payload: { serial_no: string }, thunkAPI) => {
		try {
			const { data } = await axios.post(`/atlas/pdon/delete_terminal`, payload);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const deleteLocation = createAsyncThunk(
	'/bankbox/delete_location',
	async (payload: { id: string }, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/delete_delivery_location`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const reactivateBankbox = createAsyncThunk(
	'/bankbox/activate_bank_box',
	async (payload: { serial_no: string }, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/atlas/pdon/activate_bank_box`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllTransactions = createAsyncThunk(
	'/bankbox/get_all_bankbox_transactions',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_bankbox_transactions?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.status ? '&status=' + payload.status : ''}${
					payload.range ? '&range=' + payload.range : ''
				}${payload.serial_no ? '&serial=' + payload.serial_no : ''}${
					payload.type ? '&type=' + payload.type : ''
				}${payload.search ? '&search=' + payload.search : ''}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// //(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setAllBankBoxTrx(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getMerchantAllTransactions = createAsyncThunk(
	'/bankbox/get_merchant_all_bankbox_transactions',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		//(payload);
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_bankbox_transactions?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.status ? '&status=' + payload.status : ''}${
					payload.range ? '&range=' + payload.range : ''
				}${payload.serial_no ? '&serial=' + payload.serial_no : ''}${
					payload.type ? '&type=' + payload.type : ''
				}${payload.search ? '&search=' + payload.search : ''}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				//(data);
				thunkAPI.dispatch(setMerchantAllBankBoxTrx(data?.data?.data));

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getTransactionSingle = createAsyncThunk(
	'/bankbox/get_all_bankbox_transactions',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_bankbox_transactions?
				${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}
						${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}
					
				${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.status ? '&status=' + payload.status : ''}${
					payload.range ? '&range=' + payload.range : ''
				}${payload.serial_no ? '&serial=' + payload.serial_no : ''}${
					payload.type ? '&type=' + payload.type : ''
				}${payload.search ? '&search=' + payload.search : ''}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// //(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setSingleBankBoxTrx(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleUser = createAsyncThunk(
	'/bankbox/get_single_user',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_single_user
        ${payload.email ? `?email=${payload.email || ''}` : ''}
        `
			);
			// logger.log(data?.data);
			// //(data, '--------------------');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setUser(data?.data?.data?.user));
				thunkAPI.dispatch(setSingleUserBankBoxes(data?.data?.data?.bankboxes));
				thunkAPI.dispatch(setSingleUserRequests(data?.data?.data?.requests));
				thunkAPI.dispatch(
					setSingleUserSettlement(data?.data?.data?.settlement_detail)
				);
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleUserMerchant = createAsyncThunk(
	'/bankbox/get_single_user_merchant',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_single_user${
					payload.email ? `?email=${payload.email || ''}` : ''
				}
        `
			);
			// console.log(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				thunkAPI.dispatch(setUserMerchant(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const generateAccountNumberVirtual = createAsyncThunk(
	'/bankbox/get_single_user_merchant_generate-account-virtual',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/generate_account
        `
			);
			// console.log(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// thunkAPI.dispatch(setUserMerchant(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getTopTransacting = createAsyncThunk(
	'/bankbox/get_top_transacting',
	async (payload, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_top_transacting_users
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setTopTransacting(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleBankbox = createAsyncThunk(
	'/bankbox/get_single_bankbox',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_single_bankbox?${
					payload.serial_no ? 'serial_no=' + payload.serial_no : ''
				}
        `
			);
			// //(data);

			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setSingleBankBox(data.data.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				// toast.error(error.message, {
				// 	position: 'top-right',
				// });
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleMerchantBankbox = createAsyncThunk(
	'/bankbox/get_single_bankbox_merchant',
	async (payload: any, thunkAPI) => {
		try {
			const { per_page, current_page, email } = payload;

			const searchParams = new URLSearchParams();

			if (per_page) searchParams.append('per_page', per_page);
			if (current_page) searchParams.append('current_page', current_page);
			if (email) searchParams.append('email', email);

			const query = searchParams.toString();

			const { data } = await axios.get(`/atlas/pdon/get_all_bankbox?${query}`);

			if (data?.status === 'fail') {
				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				thunkAPI.dispatch(setAllBankBoxMerchant(data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleMerchantVirtualBankbox = createAsyncThunk(
	'/bankbox/virtual_bankbox__merchant',
	async (payload: any, thunkAPI) => {
		try {
			const query = `${
				payload.serial_no ? 'serial_no=' + payload.serial_no : ''
			}${
				payload.email
					? (payload.serial_no ? '&' : '') + 'email=' + payload.email
					: ''
			}`;

			const { data } = await axios.get(
				`/atlas/pdon/virtual_terminals?${query}`
			);

			// const encryptedStr =
			// 	'3ffa203d405875597e81c03b886e4ff119d18c3264e4db63c36c3822a5601914cdf60d2302b883f2771ea83ac81479cc9a61';
			// const decrypted = decrypt2(encryptedStr);
			// ('Decrypted data:', decrypted);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setVirtualBankBoxMerchant(data.data.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				// toast.error(error.message, {
				// 	position: 'top-right',
				// });
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleBankboxFlier = createAsyncThunk(
	'/bankbox/single-babkox-flier',
	async (payload: { account_number: string }, thunkAPI) => {
		try {
			const { data } = await axios.post(
				`/generate_flier`,
				// `/atlas/pdon/generate_flier`,
				payload
			);
			// logger.log(data?.data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				// //(data);

				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllUsers = createAsyncThunk(
	'/bankbox/get_all_users',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// logger.log(payload, 'log');
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_users?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.region ? '&region=' + payload.region : ''
				}${payload.search ? '&search=' + payload.search : ''}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);
			// logger.log(data?.data, 'log');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setAllUsers(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getChartData = createAsyncThunk(
	'/bankbox/get_chart_data',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_chart_data?
        ${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}
        ${payload.date ? '&date=' + payload.date : ''}
        `
			);

			// logger.log(data?.data, 'dataun');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}

			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				thunkAPI.dispatch(setChartData(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getSingleTransaction = createAsyncThunk(
	'/bankbox/get_bankbox_single_transaction',
	async (payload: { id: string }, thunkAPI) => {
		try {
			// //(payload);
			const { data } = await axios.get(
				`/atlas/pdon/get_bankbox_single_transaction?${
					payload.id ? 'id=' + payload.id : ''
				}

        `
			);
			// logger.log(data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// thunkAPI.dispatch(setAllBankBoxTrx(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);
const exportBankboxTransaction = createAsyncThunk(
	'/bankbox/export_bankbox_transactions',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/export_bankbox_transactions?${
					payload.affiliate_app_id
						? 'affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&per_page=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? 'start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.range ? '&range=' + payload.range : ''
				}${payload.search ? '&search=' + payload.search : ''}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			// console.log('exp', data);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportMerchantTransaction = createAsyncThunk(
	'/bankbox/merchant_transactions/export',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/merchant_transactions/export?${
					payload.serial ? 'serial=' + payload.serial : ''
				}${payload.ref ? '&ref=' + payload.ref : ''}${
					payload.email ? '&email=' + payload.email : ''
				}${payload.startDate ? '&startDate=' + payload.startDate : ''}${
					payload.stopDate ? '&stopDate=' + payload.stopDate : ''
				}${payload.range ? '&range=' + payload.range : ''}`
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}
				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response?.data?.status === 'fail' &&
				error.response?.status !== 401
			) {
				return thunkAPI.rejectWithValue(error.response?.data);
			}
			return thunkAPI.rejectWithValue(error);
		}
	}
);

const exportBankboxSettlement = createAsyncThunk(
	'/bankbox/export_bankbox_settlement',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/export/merchant_settlements?${
					payload.per_page ? 'per_page=' + payload.per_page : ''
				}${payload.page ? '&page=' + payload.page : ''}${
					payload.start_date ? 'start_date=' + payload.start_date : ''
				}${payload.stop_date ? '&stop_date=' + payload.stop_date : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const exportBankboxSettlementHistory = createAsyncThunk(
	'/bankbox/export_bankbox_settlement_history',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const { data } = await axios.get(
				`/atlas/pdon/settlement/account_change_requests/export?${
					payload.per_page ? 'per_page=' + payload.per_page : ''
				}${payload.page ? '&page=' + payload.page : ''}${
					payload.start_date ? 'start_date=' + payload.start_date : ''
				}${payload.stop_date ? '&stop_date=' + payload.stop_date : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				toast.success(data?.data?.message, {
					position: 'top-right',
				});
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const getSettingsConfigBankbox = createAsyncThunk(
	'/settings-config-bankbox',
	async (payload, thunkAPI) => {
		// //("-------------------------------------------");

		try {
			const data = await axios.get(`/atlas/pdon/bankbox_config`);
			// //(data);

			if (data?.data?.status === 'fail') {
				toast.error(data?.data.message, {
					position: 'top-right',
				});
				return thunkAPI.rejectWithValue(data);
			}
			if (data?.data?.status === 'success') {
				// toast.success(data?.data.message, {
				// 	position: 'top-right',
				// });
				// //(data);

				thunkAPI.dispatch(setConfig(data?.data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllSettlements = createAsyncThunk(
	'/bankbox/get_all_settlements',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// logger.log(payload, 'log');
		try {
			const { data } = await axios.get(
				`/atlas/pdon/get_all_merchant_settlements?${
					payload.per_page ? 'perPage=' + payload.per_page : ''
				}${payload.page ? '&page=' + payload.page : ''}${
					payload.start_date ? '&start_date=' + payload.start_date : ''
				}${payload.stop_date ? '&stop_date=' + payload.stop_date : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${payload.status ? '&status=' + payload.status : ''}${
					payload.email ? '&email=' + payload.email : ''
				}
        `
			);
			// logger.log(data?.data, 'log');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				const obj = data?.data?.data;
				// //(obj);
				thunkAPI.dispatch(setSettlements(obj));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getAllSettlementsHistory = createAsyncThunk(
	'/bankbox/settlement/account_change_requests',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// //(payload);

		try {
			const { data } = await axios.get(
				`/atlas/pdon/settlement/account_change_requests?${
					payload.affiliate_app_id
						? '?affiliate_app_id=' + payload.affiliate_app_id
						: ''
				}${payload.per_page ? '&perPage=' + payload.per_page : ''}${
					payload.page ? '&page=' + payload.page : ''
				}${payload.start_date ? '&start_date=' + payload.start_date : ''}${
					payload.stop_date ? '&stop_date=' + payload.stop_date : ''
				}${payload.serial_no ? '&serial_no=' + payload.serial_no : ''}${
					payload.status ? '&status=' + payload.status : ''
				}${payload.range ? '&range=' + payload.range : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${
					payload.business_name ? '&business_name=' + payload.business_name : ''
				}${payload.email ? '&email=' + payload.email : ''}
        `
			);

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				// toast.success(data?.data?.message, {
				// 	position: 'top-right',
				// });
				// //(data?.data?.data);

				thunkAPI.dispatch(setSettlementsHistory(data?.data?.data));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const getMerchantAllSettlement = createAsyncThunk(
	'/bankbox/get_all_merchant_settlements',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// logger.log(payload, 'log');
		try {
			//('Payload:', payload);
			const { data } = await axios.get(
				`/atlas/pdon/get_all_merchant_settlements?${
					payload.per_page ? 'perPage=' + payload.per_page : ''
				}${payload.page ? '&page=' + payload.page : ''}${
					payload.start_date ? '&start_date=' + payload.start_date : ''
				}${payload.stop_date ? '&stop_date=' + payload.stop_date : ''}${
					payload.search ? '&search=' + payload.search : ''
				}${payload.status ? '&status=' + payload.status : ''}${
					payload.email ? '&email=' + payload.email : ''
				}
        `
			);
			// logger.log(data?.data, 'log');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				const obj = data?.data?.data;
				//(obj);
				thunkAPI.dispatch(setAllMerchantSettlements(obj));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

// const getAllM = createAsyncThunk(
// 	'/bankbox/get_all_settlements',
// 	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
// 		// logger.log(payload, 'log');
// 		try {
// 			const { data } = await axios.get(
// 				`/atlas/pdon/get_all_merchant_settlements?${
// 					payload.per_page ? 'perPage=' + payload.per_page : ''
// 				}${payload.page ? '&page=' + payload.page : ''}${
// 					payload.start_date ? '&start_date=' + payload.start_date : ''
// 				}${payload.stop_date ? '&stop_date=' + payload.stop_date : ''}${
// 					payload.search ? '&search=' + payload.search : ''
// 				}${payload.status ? '&status=' + payload.status : ''}${
// 					payload.email ? '&email=' + payload.email : ''
// 				}
//         `
// 			);
// 			// logger.log(data?.data, 'log');

// 			if (data?.status === 'fail') {
// 				if (typeof data?.data === 'string') {
// 					toast.error(data?.data);
// 				} else {
// 					toast.error(data?.message, {
// 						position: 'top-right',
// 					});
// 				}

// 				return thunkAPI.rejectWithValue(data);
// 			}
// 			if (data?.status === 'success') {
// 				const obj = data?.data?.data;
// 				// //(obj);
// 				thunkAPI.dispatch(setSettlements(obj));
// 				return data;
// 			}
// 		} catch (error: any) {
// 			if (error.message === 'Network Error') {
// 				toast.error(error.message, {
// 					position: 'top-right',
// 				});
// 			}
// 			if (
// 				error.response.data.status === 'fail' &&
// 				error.response.status !== 401
// 			) {
// 				return thunkAPI.rejectWithValue(error);
// 			}
// 		}
// 	}
// );
const getAllSettlementSearch = createAsyncThunk(
	'/bankbox/search/merchant_settlements',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// logger.log(payload, 'log');
		try {
			const { data } = await axios.get(
				`/atlas/pdon/search/merchant_settlements?${
					payload.search ? '&search=' + payload.search : ''
				}
        `
			);
			//(data);
			// logger.log(data?.data, 'log');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					toast.error(data?.data);
				} else {
					toast.error(data?.message, {
						position: 'top-right',
					});
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				const obj = data?.data?.data;
				// //(obj);
				thunkAPI.dispatch(setSettlements(obj));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

export const getAllSettlementHistorySearch = createAsyncThunk(
	'/bankbox/search/merchant_settlements_history',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		try {
			const params = new URLSearchParams();

			if (payload.search) {
				params.append('search', payload.search);
			}
			if (payload.page) {
				params.append('page', String(payload.page));
			}
			if (payload.per_page) {
				params.append('per_page', String(payload.per_page));
			}

			const { data } = await axios.get(
				`/atlas/pdon/settlement/account_change_requests/search?${params.toString()}`
			);
			//(data);

			if (data?.status === 'fail') {
				toast.error(
					typeof data?.data === 'string' ? data?.data : data?.message,
					{
						position: 'top-right',
					}
				);
				return thunkAPI.rejectWithValue(data);
			}

			if (data?.status === 'success') {
				const settlements = data?.data?.data;
				// //('Settlements:', settlements);
				thunkAPI.dispatch(setSettlementsHistory(settlements));
				//('Api search', data);
				//('apisettlement', settlements);
				return data;
			}
		} catch (error: any) {
			const errMsg =
				error?.response?.data?.message || error.message || 'An error occurred';
			toast.error(errMsg, { position: 'top-right' });
			return thunkAPI.rejectWithValue(error.response?.data || error);
		}
	}
);

const fetchSettlementRequest = createAsyncThunk(
	'/atlas/pdon/settlement/single_account_request',
	async (payload: GetAllBankBoxQueryParams, thunkAPI) => {
		// logger.log(payload, 'log');
		// ("------------------------redux");

		try {
			const { data } = await axios.get(
				`/atlas/pdon/settlement/single_account_request?${
					payload.email ? '&email=' + payload.email : ''
				}
        `
			);
			// (data);

			// logger.log(data?.data, 'log');

			if (data?.status === 'fail') {
				if (typeof data?.data === 'string') {
					// toast.error(data?.data);
				} else {
					// toast.error(data?.message, {
					// 	position: 'top-right',
					// });
				}

				return thunkAPI.rejectWithValue(data);
			}
			if (data?.status === 'success') {
				const obj = data?.data?.data;

				thunkAPI.dispatch(setSettlementreq(obj));
				return data;
			}
		} catch (error: any) {
			if (error.message === 'Network Error') {
				toast.error(error.message, {
					position: 'top-right',
				});
			}
			if (
				error.response.data.status === 'fail' &&
				error.response.status !== 401
			) {
				return thunkAPI.rejectWithValue(error);
			}
		}
	}
);

const initialState: BankBoxState = {
	loading: false,
	loading_fee: false,
	loading_cac: false,
	loading_settlement: false,
	loading_merchant: false,
	loading_request: false,
	loading_roles: false,
	loading_bvn: false,
	loading_nin: false,
	loading_address: false,
	loading_teams: false,
	loading_diputes: false,
	loading_terminals: false,
	isAuth: false,
	top_transacting: [],
	banks: [],
	Biz: [],
	profile: {},
	single_user_requests: [],
	single_user_bankboxes: [],
	users: {
		data: [],
		pagination: {
			perPage: 0,
			currentPage: 0,
			nextPage: null,
			prevPage: null,
			totalPages: 0,
			total: 0,
		},
	},
	all_bankbox_trx: {
		data: [],
		total: 0,
		perPage: 0,
		pagination: {
			perPage: 0,
			currentPage: 0,
			nextPage: null,
			prevPage: null,
			totalPages: 0,
			total: 0,
		},
	},
	single_bankbox_trx: {
		data: [],
		total: 0,
		perPage: 0,
		pagination: {
			perPage: 0,
			currentPage: 0,
			nextPage: null,
			prevPage: null,
			totalPages: 0,
			total: 0,
		},
	},
	dashboard_summary: {
		bankSwitchRequests: 0,
		collectionBalance: 0,
		totalPendingRequest: 0,
		totalBankBoxDisbursed: 0,
		totalUsers: 0,
		merchantBalance: 0,
	},
	chart_data: {},
	settlement_detail: {},
	all_bankbox: {},
	virtual_bankbox: {},
	virtual_terminal: [],
	all_bankbox_data: [],
	all_bankbox__merchant: [],
	virtual_bankbox__merchant: [],
	all_bankbox_request: {
		data: [],
		perPage: 0,
		currentPage: 0,
		nextPage: null,
		prevPage: null,
		totalPages: 0,
		total: 0,
	},
	all_disputes: {
		data: [],
		pagination: {
			per_page: 0,
			current_page: 0,
			next_page: null,
			prev_page: null,
			total_pages: 0,
			total: 0,
		},
	},
	all_bvn: {
		data: [],
		perPage: 0,
		currentPage: 0,
		nextPage: null,
		prevPage: null,
		totalPages: 0,
		total: 0,
	},
	all_nin: {
		data: [],
		pagination: {
			per_page: 0,
			current_page: 0,
			next_page: null,
			prev_page: null,
			total_pages: 0,
			total: 0,
		},
	},
	all_cac: {
		data: [],
		pagination: {
			per_page: 0,
			current_page: 0,
			next_page: null,
			prev_page: null,
			total_pages: 0,
			total: 0,
		},
	},
	all_address: {
		data: [],
		pagination: {
			per_page: 0,
			current_page: 0,
			next_page: null,
			prev_page: null,
			total_pages: 0,
			total: 0,
		},
	},
	all_fees: {
		data: [],
		pagination: {
			per_page: 0,
			current_page: 0,
			next_page: null,
			prev_page: null,
			total_pages: 0,
			total: 0,
		},
	},
	partner_info: {},
	user: {
		id: 0,
		fname: '',
		lname: '',
		poseidon_email: '',
		bvn: '',
		nin: '',
		phone: '',
		affiliate_app: '',
		affiliate_app_id: '',
		poseidon_business_name: '',
		poseidon_business_address: '',
		poseidon_business_type: null,
		poseidon_business_description: '',
		poseidon_profile_reference: '',
		business_category: '',
		region: '',
		created_at: '',
		updated_at: '',
		lga: '',
	},
	all_fees_no_page: [],
	single_bankbox: {},
	all_states: [],
	all_lga: [],
	all_locations: [],
	config: {},
	user_merchant: {},
	user_merchant_settlement: {},
	partner_settlement_info: {},
	policies: [],
	roles: [],
	teams: {},
	single_role: {},
	account_change_requests: {},
	all_merchant_eletricity: {},
	all_settlement: {},
	all_merchant_bankbox_trx: {},
	get_single_all_bankbox_request: {},
	all_single_disputes: {},
	all_merchant_bankbox_settlement: {},
	loading_Partner_info: false,
	settlement_detail_req: {},
	// initialize other state properties
};

const formatBankList = (param: any) => {
	if (param?.length > 0) {
		const newList = param?.map((chi: any) => {
			return { ...chi, label: chi?.name, value: chi?.code };
		});
		return newList;
	}
};

export const bankboxSlice = createSlice({
	name: 'bankbox',
	initialState,

	reducers: {
		setBankBoxUser: (state, action) => {
			state.user = action.payload;
			state.isAuth = true;
		},
		setTeams: (state, action) => {
			state.teams = action.payload;
			state.isAuth = true;
		},
		setBankBoxStates: (state, action) => {
			state.all_states = action.payload;
			state.isAuth = true;
		},
		setSingleRole: (state, action) => {
			state.single_role = action.payload;
			state.isAuth = true;
		},
		setBankBoxLga: (state, action) => {
			state.all_lga = action.payload;
			state.isAuth = true;
		},
		setBankBoxPartnerType: (state, action) => {
			state.partner_info = action.payload;
			state.partner_settlement_info = action.payload?.settlement_detail;
			state.isAuth = true;
		},
		setBankBoxBanks: (state, action) => {
			state.banks = action.payload;
			state.isAuth = true;
		},
		setmerbiz: (state, action) => {
			state.Biz = action.payload;
			state.isAuth = true;
		},
		updateBVNStatusLocally: (
			state: BankBoxState, // Type the state explicitly
			action: PayloadAction<{ email: string; status: number }>
		) => {
			const { email, status } = action.payload;

			// Update the status in the state
			state.all_nin.data = state.all_nin.data.map((item: NinData) => {
				// Explicitly type item as NinData to access email and status
				const currentItem = item as NinData;
				return currentItem.email === email
					? { ...currentItem, status }
					: currentItem;
			});
		},

		setAllUsers: (state, action) => {
			state.users = action.payload;
			state.isAuth = true;
		},
		setSettlementreq: (state, action) => {
			state.settlement_detail_req = action.payload;
			state.isAuth = true;
		},
		setAllFees: (state, action) => {
			state.all_fees = action.payload;
			state.isAuth = true;
		},
		setAllLocations: (state, action) => {
			state.all_locations = action.payload;
			state.isAuth = true;
		},
		setAllFeesNoPage: (state, action) => {
			state.all_fees_no_page = action.payload;
			state.isAuth = true;
		},
		setUser: (state, action) => {
			state.user = action.payload;
			state.isAuth = true;
		},
		setSummary: (state, action) => {
			state.dashboard_summary = action.payload;
			state.isAuth = true;
		},
		setAllBankBox: (state, action) => {
			state.all_bankbox = action.payload;
			state.all_bankbox_data = action.payload?.data;
			state.isAuth = true;
		},
		setAllBankBoxVirtual: (state, action) => {
			state.virtual_bankbox = action.payload;
			state.virtual_terminal = action.payload?.data;
			state.isAuth = true;
		},
		setAllBankBoxMerchant: (state, action) => {
			state.all_bankbox__merchant = action.payload?.data;
			state.isAuth = true;
		},
		setVirtualBankBoxMerchant: (state, action) => {
			state.virtual_bankbox__merchant = action.payload?.data;
			state.isAuth = true;
		},
		setSingleBankBox: (state, action) => {
			state.single_bankbox = action.payload;
			state.isAuth = true;
		},
		setChartData: (state, action) => {
			state.chart_data = action.payload;
			state.isAuth = true;
		},

		setSingleUserBankBoxes: (state, action) => {
			state.single_user_bankboxes = action.payload;
			state.isAuth = true;
		},
		setSingleUserRequests: (state, action) => {
			state.single_user_requests = action.payload;
			state.isAuth = true;
		},
		setSingleUserSettlement: (state, action) => {
			state.settlement_detail = action.payload;
			state.isAuth = true;
		},
		setAllBankBoxRequest: (state, action) => {
			state.all_bankbox_request = action.payload;
			state.isAuth = true;
		},
		setAllSingleBankBoxRequest: (state, action) => {
			state.get_single_all_bankbox_request = action.payload;
			state.isAuth = true;
		},
		setAllDisputes: (state, action) => {
			state.all_disputes = action.payload;
			state.isAuth = true;
		},
		setAllBVN: (state, action) => {
			state.all_bvn = action.payload;
			state.isAuth = true;
		},
		setAllNIN: (state, action) => {
			state.all_nin = action.payload;
			state.isAuth = true;
		},
		setAllCAC: (state, action) => {
			state.all_cac = action.payload;
			state.isAuth = true;
		},
		setAllAddress: (state, action) => {
			state.all_address = action.payload;
			state.isAuth = true;
		},
		setSingleAllDisputes: (state, action) => {
			state.all_single_disputes = action.payload;
			state.isAuth = true;
		},
		setTopTransacting: (state, action) => {
			state.top_transacting = action.payload;
			state.isAuth = true;
		},
		setPolicies: (state, action) => {
			state.policies = action.payload;
			state.isAuth = true;
		},
		setRoles: (state, action) => {
			state.roles = action.payload;
			state.isAuth = true;
		},
		setAllBankBoxTrx: (state, action) => {
			state.all_bankbox_trx = action.payload;
			state.isAuth = true;
		},
		setMerchantAllBankBoxTrx: (state, action) => {
			state.all_merchant_bankbox_trx = action.payload;
			state.isAuth = true;
		},
		// setMerchantAllBankBoxTrx: (state, action) => {
		// 	state.all_merchant_bankbox_trx = action.payload;
		// 	state.isAuth = true;
		// },
		setSingleBankBoxTrx: (state, action) => {
			state.single_bankbox_trx = action.payload;
			state.isAuth = true;
		},
		setProfile: (state, action) => {
			state.profile = action.payload;
			state.isAuth = true;
		},
		setPartnerSettlementInfo: (state, action) => {
			// state.partner_settlement_info = action.payload;
			state.isAuth = true;
		},
		setSettlements: (state, action) => {
			state.all_settlement = action.payload;
		},
		setSettlementsHistory: (state, action) => {
			state.account_change_requests = action.payload;
		},
		setAllMerchantSettlements: (state, action) => {
			state.all_merchant_bankbox_settlement = action.payload;
			state.isAuth = true;
		},
		setConfig: (state, action) => {
			state.config = action.payload;
			state.isAuth = true;
		},
		setUserMerchant: (state, action) => {
			state.user_merchant = action.payload;
			state.user_merchant_settlement = action.payload?.settlement_detail;
			state.isAuth = true;
		},
	},

	extraReducers: (builder) => {
		// Pending state
		builder
			.addCase(createUser.pending, (state) => {
				state.loading = true;
			})
			.addCase(deviceReq.pending, (state) => {
				state.loading = true;
			})
			.addCase(raiseDispute.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllTeams.pending, (state) => {
				state.loading_teams = true;
			})
			.addCase(getRoles.pending, (state) => {
				state.loading_roles = true;
			})
			.addCase(updateUser.pending, (state) => {
				state.loading = true;
			})
			.addCase(addSettleMentAccountPartner.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(editSettleMentAccountPartner.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(requestSettleMentAccountPartner.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(requestSettleMentAccountMerchant.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(updateUserFee.pending, (state) => {
				state.loading = true;
			})
			.addCase(getBankboxLocations.pending, (state) => {
				state.loading = true;
			})
			.addCase(sendCustomEmail.pending, (state) => {
				state.loading = true;
			})
			.addCase(getDashboardSummary.pending, (state) => {
				state.loading = true;
			})
			.addCase(activateBankbox.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllBankBox.pending, (state) => {
				state.loading = true;
			})
			.addCase(getVirtualTerminal.pending, (state) => {
				state.loading = true;
			})
			.addCase(singleTerminal.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllSettlements.pending, (state) => {
				state.loading_settlement = true;
			})
			.addCase(getBankboxPartner.pending, (state) => {
				state.loading_Partner_info = true;
			})
			.addCase(getAllSettlementsHistory.pending, (state) => {
				state.loading_settlement = true;
			})
			.addCase(getAllSettlementSearch.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllSettlementHistorySearch.pending, (state) => {
				fetchSettlementRequest;
				state.loading = true;
			})
			.addCase(fetchSettlementRequest.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllBankBoxRequest.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllSingleBankBoxRequest.pending, (state) => {
				state.loading_request = true;
			})
			.addCase(exportUsers.pending, (state) => {
				state.loading = true;
			})
			.addCase(exportBankboxes.pending, (state) => {
				state.loading = true;
			})
			.addCase(assignBankbox.pending, (state) => {
				state.loading = true;
			})
			.addCase(assignBankboxVirtual.pending, (state) => {
				state.loading = true;
			})
			.addCase(deactivateBankbox.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSingleUser.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSingleUserMerchant.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSingleBankbox.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllUsers.pending, (state) => {
				state.loading = true;
			})
			.addCase(getChartData.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSingleTransaction.pending, (state) => {
				state.loading = true;
			})
			.addCase(exportBankboxTransaction.pending, (state) => {
				state.loading = true;
			})
			.addCase(exportBankboxSettlement.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(exportMerchantTransaction.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(exportBankboxSettlementHistory.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(getAllTransactions.pending, (state) => {
				state.loading = true;
			})
			.addCase(getMerchantAllSettlement.pending, (state) => {
				state.loading_merchant = true;
			})
			.addCase(getMerchantAllTransactions.pending, (state) => {
				state.loading_roles = true;
			})
			.addCase(getProfile.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateProfile.pending, (state) => {
				state.loading = true;
			})

			// .addCase(uploadLogo.pending, (state) => {
			// 	state.loading = true;
			// })
			.addCase(reactivateBankbox.pending, (state) => {
				state.loading = true;
			})
			.addCase(setBankboxKey.pending, (state) => {
				state.loading = true;
			})
			.addCase(createFeeCategory.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(editFeeCategory.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(getAllFees.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSingleRole.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(changeRequestStatus.pending, (state) => {
				state.loading_fee = true;
			})
			.addCase(getAllDisputes.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllBVN.pending, (state) => {
				state.loading_bvn = true;
			})
			.addCase(searchBVNRecords.pending, (state) => {
				state.loading_bvn = true;
			})
			.addCase(searchNINRecords.pending, (state) => {
				state.loading_nin = true;
			})
			.addCase(handleBVNAction.pending, (state) => {
				state.loading_bvn = true;
			})
			// .addCase(handleNINAction.pending, (state) => {
			// 	state.loading_nin = true;
			// })
			.addCase(getAllNIN.pending, (state) => {
				state.loading_nin = true;
			})
			.addCase(getAllCAC.pending, (state) => {
				state.loading_cac = true;
			})
			.addCase(getAllAddress.pending, (state) => {
				state.loading_address = true;
			})
			.addCase(searchMerchantAddresses.pending, (state) => {
				state.loading_address = true;
			})
			.addCase(getSingleAllDisputes.pending, (state) => {
				state.loading_diputes = true;
			});

		// Fulfilled state
		builder
			.addCase(createUser.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getBankboxPartner.fulfilled, (state) => {
				state.loading_Partner_info = false;
			})
			.addCase(deviceReq.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(raiseDispute.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllTeams.fulfilled, (state) => {
				state.loading_teams = false;
			})
			.addCase(getAllSettlements.fulfilled, (state) => {
				state.loading_settlement = false;
			})
			.addCase(getAllSettlementsHistory.fulfilled, (state) => {
				state.loading_settlement = false;
			})
			.addCase(getAllSettlementSearch.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllSettlementHistorySearch.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(fetchSettlementRequest.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getRoles.fulfilled, (state) => {
				state.loading_roles = false;
			})
			.addCase(addSettleMentAccountPartner.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(editSettleMentAccountPartner.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(exportBankboxSettlement.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(exportMerchantTransaction.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(exportBankboxSettlementHistory.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(requestSettleMentAccountPartner.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(requestSettleMentAccountMerchant.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(updateUser.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(updateUserFee.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getBankboxLocations.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(sendCustomEmail.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllFees.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(createFeeCategory.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(editFeeCategory.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(getAllDisputes.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllBVN.fulfilled, (state) => {
				state.loading_bvn = false;
			})
			.addCase(searchBVNRecords.fulfilled, (state) => {
				state.loading_bvn = false;
			})
			.addCase(searchNINRecords.fulfilled, (state) => {
				state.loading_nin = false;
			})
			.addCase(handleBVNAction.fulfilled, (state) => {
				state.loading_bvn = false;
			})
			// .addCase(handleNINAction.fulfilled, (state) => {
			// 	state.loading_nin = false;
			// })
			.addCase(getAllNIN.fulfilled, (state) => {
				state.loading_nin = false;
			})
			.addCase(getAllCAC.fulfilled, (state) => {
				state.loading_cac = false;
			})
			.addCase(getAllAddress.fulfilled, (state) => {
				state.loading_address = false;
			})
			.addCase(searchMerchantAddresses.fulfilled, (state) => {
				state.loading_address = false;
			})
			.addCase(getSingleAllDisputes.fulfilled, (state) => {
				state.loading_diputes = false;
			})
			.addCase(getDashboardSummary.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(activateBankbox.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllBankBox.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getVirtualTerminal.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(singleTerminal.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllBankBoxRequest.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllSingleBankBoxRequest.fulfilled, (state) => {
				state.loading_request = false;
			})
			.addCase(exportUsers.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(exportBankboxes.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(assignBankbox.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(assignBankboxVirtual.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deactivateBankbox.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getSingleUser.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getSingleUserMerchant.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getSingleBankbox.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllUsers.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getChartData.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getSingleTransaction.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(exportBankboxTransaction.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getAllTransactions.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getMerchantAllSettlement.fulfilled, (state) => {
				state.loading_merchant = false;
			})
			.addCase(getMerchantAllTransactions.fulfilled, (state) => {
				state.loading_roles = false;
			})
			.addCase(getProfile.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(updateProfile.fulfilled, (state) => {
				state.loading = false;
			})
			// .addCase(uploadLogo.fulfilled, (state) => {
			// 	state.loading = false;
			// })
			.addCase(reactivateBankbox.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(changeRequestStatus.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(getSingleRole.fulfilled, (state) => {
				state.loading_fee = false;
			})
			.addCase(setBankboxKey.fulfilled, (state) => {
				state.loading = false;
			});

		// Rejected state
		builder
			.addCase(createUser.rejected, (state) => {
				state.loading = false;
			})
			.addCase(deviceReq.rejected, (state) => {
				state.loading = false;
			})
			.addCase(raiseDispute.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getRoles.rejected, (state) => {
				state.loading_roles = false;
			})
			.addCase(getAllSettlements.rejected, (state) => {
				state.loading_settlement = false;
			})
			.addCase(getAllSettlementsHistory.rejected, (state) => {
				state.loading_settlement = false;
			})
			.addCase(getAllSettlementSearch.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllSettlementHistorySearch.rejected, (state) => {
				state.loading = false;
			})
			.addCase(fetchSettlementRequest.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllTeams.rejected, (state) => {
				state.loading_teams = false;
			})
			.addCase(addSettleMentAccountPartner.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(editSettleMentAccountPartner.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(exportBankboxSettlement.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(exportMerchantTransaction.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(exportBankboxSettlementHistory.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(requestSettleMentAccountPartner.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(requestSettleMentAccountMerchant.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(updateUser.rejected, (state) => {
				state.loading = false;
			})
			.addCase(updateUserFee.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getBankboxLocations.rejected, (state) => {
				state.loading = false;
			})
			.addCase(sendCustomEmail.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllFees.rejected, (state) => {
				state.loading = false;
			})
			.addCase(createFeeCategory.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(editFeeCategory.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(getAllDisputes.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllBVN.rejected, (state) => {
				state.loading = false;
			})
			.addCase(searchBVNRecords.rejected, (state) => {
				state.loading_bvn = false;
			})
			.addCase(searchNINRecords.rejected, (state) => {
				state.loading_nin = false;
			})
			.addCase(handleBVNAction.rejected, (state) => {
				state.loading_bvn = false;
			})
			// .addCase(handleNINAction.rejected, (state) => {
			// 	state.loading_nin = false;
			// })

			.addCase(getBankboxPartner.rejected, (state) => {
				state.loading_Partner_info = false;
			})
			.addCase(getAllNIN.rejected, (state) => {
				state.loading_nin = false;
			})
			.addCase(getAllCAC.rejected, (state) => {
				state.loading_cac = false;
			})
			.addCase(getAllAddress.rejected, (state) => {
				state.loading_address = false;
			})
			.addCase(searchMerchantAddresses.rejected, (state) => {
				state.loading_address = false;
			})
			.addCase(getSingleAllDisputes.rejected, (state) => {
				state.loading_diputes = false;
			})
			.addCase(getDashboardSummary.rejected, (state) => {
				state.loading = false;
			})
			.addCase(activateBankbox.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllBankBox.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getVirtualTerminal.rejected, (state) => {
				state.loading = false;
			})
			.addCase(singleTerminal.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllBankBoxRequest.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllSingleBankBoxRequest.rejected, (state) => {
				state.loading_request = false;
			})
			.addCase(exportUsers.rejected, (state) => {
				state.loading = false;
			})
			.addCase(exportBankboxes.rejected, (state) => {
				state.loading = false;
			})
			.addCase(assignBankbox.rejected, (state) => {
				state.loading = false;
			})
			.addCase(assignBankboxVirtual.rejected, (state) => {
				state.loading = false;
			})
			.addCase(deactivateBankbox.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getSingleUser.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getSingleUserMerchant.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getSingleBankbox.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllUsers.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getChartData.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getSingleTransaction.rejected, (state) => {
				state.loading = false;
			})
			.addCase(exportBankboxTransaction.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getAllTransactions.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getMerchantAllTransactions.rejected, (state) => {
				state.loading_roles = false;
			})
			.addCase(getMerchantAllSettlement.rejected, (state) => {
				state.loading_merchant = false;
			})
			.addCase(getProfile.rejected, (state) => {
				state.loading = false;
			})
			.addCase(updateProfile.rejected, (state) => {
				state.loading = false;
			})
			// .addCase(uploadLogo.rejected, (state) => {
			// 	state.loading = false;
			// })
			.addCase(reactivateBankbox.rejected, (state) => {
				state.loading = false;
			})
			.addCase(setBankboxKey.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(getSingleRole.rejected, (state) => {
				state.loading_fee = false;
			})
			.addCase(changeRequestStatus.rejected, (state) => {
				state.loading_fee = false;
			});
	},
});

// Action creators are generated for each case reducer function
export const {
	setBankBoxUser,
	setRoles,
	setSummary,
	setAllBankBox,
	setAllBankBoxMerchant,
	setVirtualBankBoxMerchant,
	setAllBankBoxRequest,
	setAllSingleBankBoxRequest,
	setAllBankBoxTrx,
	setAllUsers,
	setAllBankBoxVirtual,
	setChartData,
	setTopTransacting,
	setPolicies,
	setUser,
	setProfile,
	setPartnerSettlementInfo,
	setSingleUserBankBoxes,
	setAllDisputes,
	setAllBVN,
	setAllNIN,
	setAllCAC,
	setAllAddress,
	setSingleAllDisputes,
	setAllFees,
	setSingleUserRequests,
	setSingleUserSettlement,
	setAllFeesNoPage,
	setBankBoxPartnerType,
	setBankBoxBanks,
	setmerbiz,
	setSingleBankBox,
	setBankBoxLga,
	setBankBoxStates,
	setAllLocations,
	setConfig,
	setSingleBankBoxTrx,
	setUserMerchant,
	setTeams,
	setSingleRole,
	setSettlements,
	setSettlementsHistory,
	setAllMerchantSettlements,
	setMerchantAllBankBoxTrx,
	setSettlementreq,
} = bankboxSlice.actions;

export const bankboxAPI: BankBoxRequests = {
	editLocationPickUp,
	updateBusinessMerchant,
	setInactiveDaysTerminal,
	getAllBankBoxForMerchant,
	getVirtualBankBoxForMerchant,
	searchVirtualBankBoxForMerchant,
	resendTeamInvite,
	removeTeamMember,
	acceptInviteTeamMember,
	searchMerchantAddresses,
	inviteTeamMember,
	manageTeamMember,
	createUser,
	deviceReq,
	raiseDispute,
	updateUser,
	updateUserFee,
	getDashboardSummary,
	activateBankbox,
	getAllBankBox,
	getVirtualTerminal,
	singleTerminal,
	getAllBankBoxRequest,
	getAllSingleBankBoxRequest,
	exportUsers,
	exportBankboxes,
	getAllDisputes,
	getSingleAllDisputes,
	exportEODBankboxes,
	getTopTransacting,
	assignBankbox,
	deactivateBankbox,
	reactivateBankbox,
	getSingleUser,
	getAllBVN,
	handleBVNAction,
	handleNINAction,
	getAllNIN,
	getAllCAC,
	getAllAddress,
	getSingleUserMerchant,
	getSingleBankbox,
	getProfile,
	getAllUsers,
	getChartData,
	getSingleMerchantBankbox,
	getSingleMerchantVirtualBankbox,
	getSingleTransaction,
	exportBankboxTransaction,
	updateProfile,
	getAllTransactions,
	getTransactionSingle,
	uploadLogo,
	setBankboxKey,
	createFeeCategory,
	editFeeCategory,
	getAllFees,
	getRoles,
	sendCustomEmail,
	changeDisputeStatus,
	exportDisputes,
	exportVirtualTerminal,
	exportBVN,
	exportAirtimeRecords,
	exportDataRecords,
	exportElectricityRecords,
	exportCableRecords,
	exportBettingRecords,
	exportNIN,
	exportCAC,
	exportAddress,
	exportFees,
	getAllFeesWithoutPagination,
	changeRequestStatus,
	getBankboxPartner,
	deleteBankbox,
	getBankboxStates,
	getBankboxLgaByStates,
	createLocationPickUp,
	getBankboxLocations,
	deleteLocation,
	getSettingsConfigBankbox,
	addSettleMentAccountPartner,
	editSettleMentAccountPartner,
	getSingleBankboxFlier,
	getBankboxBanks,
	getMerBIZ,
	getBankboxBankValidate,
	requestSettleMentAccountPartner,
	requestSettleMentAccountMerchant,
	getPolicies,
	createRole,
	searchBVNRecords,
	searchNINRecords,
	getAllTeams,
	getInvitationDetails,
	getSingleRole,
	updateRole,
	getAllSettlements,
	getAllSettlementsHistory,
	getAllSettlementSearch,
	getAllSettlementHistorySearch,
	exportBankboxSettlement,
	exportMerchantTransaction,
	exportBankboxSettlementHistory,
	changeTerminalActiveDays,
	getMerchantAllTransactions,
	getMerchantAllSettlement,
	fetchSettlementRequest,
	generateAccountNumberVirtual,
	assignBankboxVirtual,
};

export const { updateBVNStatusLocally } = bankboxSlice.actions;
export default bankboxSlice.reducer;

// smiles i used a different approach here
